import { createContext } from 'react';
import { atom, createStore } from 'jotai/vanilla';

import { initialAiBuilderChatState } from '../constants';

import { type AiBuilderChatState } from './types';

export type AiBuilderChatStore = ReturnType<typeof createStore>;

export const aiBuilderChatStateAtom = atom<AiBuilderChatState>(
  initialAiBuilderChatState,
);

export type AiBuilderChatStateAtom = typeof aiBuilderChatStateAtom;

export const createAiBuilderChatStore = (
  initialState: AiBuilderChatState = initialAiBuilderChatState,
): AiBuilderChatStore => {
  const store = createStore();
  store.set(aiBuilderChatStateAtom, initialState);
  return store;
};

export const AiBuilderChatStoreContext =
  createContext<AiBuilderChatStore | null>(null);
